import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LayoutRightLoader } from "../../../right";

interface IDrawerEntityDataLoaderProps {
  entityTitle: string;
}

export const DrawerEntityDataLoader: FC<IDrawerEntityDataLoaderProps> = ({
  entityTitle,
}) => {
  const { t } = useTranslation();

  return (
    <LayoutRightLoader>
      {`${t("ui.LOADING_ENTITY_DATA", { entity: entityTitle })}...`}
    </LayoutRightLoader>
  );
};
